import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { ITask } from '@nimbus-assistant/models/task.model';
import { AssistantTasksService } from '@nimbus-assistant/services/assistant-tasks.service';
import { MessageService } from '@nimbus-assistant/services/message.service';
import { SettingsService } from '@nimbus-assistant/services/settings.service';
import { OpenInBrowserMessage } from '@nimbus-assistant/models/web-view-messages/open-in-browser-message';
import { SharedUIModule } from '@nimbus-library/features/shared/shared.ui.module';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { IconWeight } from '@nimbus-library/features/shared/directives/icon-weight.enum';

@Component({
  standalone: true,
  selector: 'app-task-context-tab',
  templateUrl: './task-context-tab.component.html',
  styleUrls: ['./task-context-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, SharedUIModule],
})
export class TaskContextTabComponent implements OnInit {
  @Input() public task: ITask;

  public readonly ICONS = ICONS;
  public readonly IconWeight = IconWeight;
  public readonly TranslationKeys = TranslationKeys;
  public loading$: Observable<boolean> = of(false);

  public constructor(
    private readonly settingsService: SettingsService,
    private readonly tasksService: AssistantTasksService,
  ) {}

  public ngOnInit(): void {
    this.loading$ = this.tasksService.contextParamsLoading$.pipe(
      map((ids) => ids.has(this.task?.unifiedConversationId)),
      distinctUntilChanged(),
    );
  }

  public copyAll(): void {
    let copyText = '';
    for (const entry of this.task?.contextData ?? []) {
      copyText += `${entry.key}:\n${entry.value}\n\n`;
    }
    navigator.clipboard.writeText(copyText);
  }

  public copyValue(value: string): void {
    navigator.clipboard.writeText(value);
  }

  public openUrl(url: string): void {
    const message = new OpenInBrowserMessage();
    message.url = url;
    MessageService.SendOpenInBrowser(message);
  }

  public openMySessions(): void {
    this.openUrl(this.settingsService.portalSessionsUrl);
  }
}
